// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2g0Wi","buttons":"Footer_buttons__1Aou3"};